import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Copy, Dropdown } from '@elparking/components'

import {
    HOUR_FORMAT,
} from 'commons/js/constants'
import { formatDate, mergeDate } from 'commons/js/util/dateConverter'

import { buildHoursAndMinutes, calculateSelectedHourOption } from './buildTime'

import Picker from './Picker'
import { defineMessages, injectIntl } from 'react-intl'

const messages = defineMessages({
    ariaTimePicker: {
        defaultMessage: 'Selecciona la hora',
    },
})
function TimePicker ({
    value,
    onChange,
    placeholder,
    disabledHours,
    onFocus,
    intl,
}) {
    const handleChange = (time) => {
        const [hours, minutes] = time.split(':')
        onChange(mergeDate(value, { 'hours': parseInt(hours, 10), 'minutes': parseInt(minutes, 10) }))
    }

    const buildOptions = (dates, displayFormat, format) => {
        return dates.map((date) => ({
            label: formatDate(date, displayFormat),
            value: formatDate(date, format),
        }))
    }

    const hoursMinutes = buildHoursAndMinutes(value, disabledHours)
    const hoursMinutesOptions = buildOptions(hoursMinutes, HOUR_FORMAT, HOUR_FORMAT)
    const selectedHour = value && formatDate(calculateSelectedHourOption(value, hoursMinutes), HOUR_FORMAT)

    return (
        <Dropdown
          ariaLabel={intl.formatMessage(messages.ariaTimePicker)}
          dataTest='timepicker-hour'
          renderPlaceholder={() => <Copy padding='0' fontSize='small' color='lightGray' fontWeight='regular'>
              {placeholder}
          </Copy>}
          focusOnClick={false}
          selectorElement={Picker}
          options={hoursMinutesOptions}
          onChange={({ value }) => handleChange(value)}
          value={selectedHour}
          disabled={!value}
          defaultValue={selectedHour}
          iconPlaceholderElement={() => <Icon color='gray' type='clock-alt' />}
          onFocus={onFocus}
        />
    )
}

TimePicker.propTypes = {
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    disabledHours: PropTypes.any,
    onFocus: PropTypes.func,
    intl: PropTypes.object,
}

export default injectIntl(TimePicker)
